import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TruckFilledSvg from "@ant-design/icons-svg/es/asn/TruckFilled";
import AntdIcon from "../components/AntdIcon";
var TruckFilled = function TruckFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TruckFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TruckFilled.displayName = 'TruckFilled';
}
export default /*#__PURE__*/React.forwardRef(TruckFilled);